export const E_GreenSocket_MessageTypes = {
	LOGIN: "LOGIN",
	SUBSCRIBE: "SUBSCRIBE",
	UNSUBSCRIBE: "UNSUBSCRIBE",
	SYNC: "SYNC",
	ERROR: "ERROR",
	MESSAGE: "MESSAGE",
};

export const E_GreenSocket_UnsubscribeReason = {
	//Subscribed topic has set resubscribe = false
	NOT_RESUBSCRIBED: "NOT_RESUBSCRIBED",
};

export const E_GreenSocket_DisconnectReason = {
	NEW_CONNECTION: "NEW_CONNECTION",
};

export const E_GreenSocket_Error = {
	INVALID_URL: "INVALID_URL",
};
